import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef3f53c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoices" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Fakturaoversikt", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Filter", -1))
const _hoisted_4 = { class: "date-from" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dato fra", -1))
const _hoisted_6 = {
  key: 0,
  class: "field-error"
}
const _hoisted_7 = { class: "date-to" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dato til", -1))
const _hoisted_9 = {
  key: 0,
  class: "field-error"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "date-info" }, [
  /*#__PURE__*/_createTextVNode(" Datoer er "),
  /*#__PURE__*/_createElementVNode("strong", null, "fra og med"),
  /*#__PURE__*/_createTextVNode(" samt "),
  /*#__PURE__*/_createElementVNode("strong", null, "til og med")
], -1))
const _hoisted_11 = { class: "type" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Betalingsmåte", -1))
const _hoisted_13 = {
  key: 0,
  class: "field-error"
}
const _hoisted_14 = { class: "credit-note" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Kreditnota", -1))
const _hoisted_16 = { class: "labour" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = {
  key: 0,
  class: "field-error"
}
const _hoisted_19 = { class: "invoice-number" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "buttons" }
const _hoisted_22 = {
  key: 0,
  class: "invoices-table"
}
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_InvoicesTable = _resolveComponent("InvoicesTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _createVNode(_component_Card, { class: "filter" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.date_from) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.date_from]
            ]),
            (_ctx.form.errors.date_from)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.form.errors.date_from), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.date_to) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.date_to]
            ]),
            (_ctx.form.errors.date_to)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.form.errors.date_to), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Multiselect, {
              class: "selector",
              modelValue: _ctx.form.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.type) = $event)),
              canClear: false,
              options: [
              {
                label: 'Alle salg',
                value: 'all',
              },
              {
                label: 'Fakturasalg',
                value: 'invoices',
              },
              {
                label: 'Nettsalg',
                value: 'weborders',
              },
            ]
            }, null, 8, ["modelValue"]),
            (_ctx.form.errors.type)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.form.errors.type), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Multiselect, {
              class: "selector",
              modelValue: _ctx.form.credit_note,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.credit_note) = $event)),
              canClear: false,
              options: [
              {
                label: 'Vis alle',
                value: 'all',
              },
              {
                label: 'Kun kreditnota',
                value: 'only-credit-note',
              },
              {
                label: 'Ekskluder kreditnota',
                value: 'exclude-credit-note',
              },
            ]
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.only_labour) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.only_labour]
              ]),
              _createTextVNode(" Kun arbeid ")
            ]),
            (_ctx.form.errors.only_labour)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.form.errors.only_labour), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, [
              _createTextVNode(" Fakturanr "),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.invoice_number) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.invoice_number]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_Button, {
              color: "green",
              onClick: _ctx.submit,
              disabled: _ctx.form.processing
            }, {
              default: _withCtx(() => [
                (_ctx.form.processing)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 0,
                      class: "loading-icon",
                      type: "mdi",
                      path: _ctx.mdiLoading
                    }, null, 8, ["path"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" Hent liste ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_Button, {
              color: "primary",
              onClick: _ctx.exportInvoices
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SvgIcon, {
                  class: "button-icon",
                  type: "mdi",
                  path: _ctx.mdiFileExport
                }, null, 8, ["path"]),
                _createTextVNode(" Eksporter til Excel ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              color: "secondary",
              onClick: _ctx.print,
              disabled: _ctx.form.processing
            }, {
              default: _withCtx(() => [
                (_ctx.form.processing)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 0,
                      class: "loading-icon",
                      type: "mdi",
                      path: _ctx.mdiLoading
                    }, null, 8, ["path"]))
                  : (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 1,
                      class: "button-icon",
                      type: "mdi",
                      path: _ctx.printIcon
                    }, null, 8, ["path"])),
                _createTextVNode(" Skriv ut ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _: 1
      })
    ], 32),
    (_ctx.invoices)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_component_InvoicesTable, { invoices: _ctx.invoices }, null, 8, ["invoices"]),
          (_ctx.invoices?.total === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Ingen resultat"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}